let storeRef = null;
let impersonationExpiredHandler = null;

export function registerStore(store) {
  storeRef = store;
}

export function registerImpersonationExpiredHandler(handler) {
  impersonationExpiredHandler = handler;
}

export function dispatchImpersonationExpired() {
  impersonationExpiredHandler?.();
}

export function getStoreState() {
  return storeRef?.getState();
}

export function dispatchStoreAction(action) {
  return storeRef?.dispatch(action);
}
